/* global modForm modUtils */
/**
 * Saves user information to cookie
 * @param {String} name - key name for the object being stored on the cookie
 * @param {String} value - value for the object being stored on the cookie
 */
export function saveUserInfoToCookie(name, value) {
	if (name.toLowerCase().includes('zip')) {
		modForm.userObj.zip = value;
	} else {
		modForm.userObj[name] = value;
	}

	modUtils.setCookie('userInfo', JSON.stringify(modForm.userObj), 526740);
}
